import React, { createContext, useContext } from 'react';
import { ComputeResourceDiscoveryApi } from '../../api';
import { CRDAzureConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { useRefreshContext } from '../RefreshContext';

interface AzureContextProps {
  api: ComputeResourceDiscoveryApi;
  azureConfigs: CRDAzureConfig[];
  projectCode: string;
  refreshContext?: ReturnType<typeof useRefreshContext>;
}

const AzureContext = createContext<AzureContextProps | undefined>(undefined);

export const useAzureContext = () => {
  const context = useContext(AzureContext);
  if (!context) {
    throw new Error('AzureContext must be used within a AzureProvider');
  }
  return context;
};

export const AzureContextProvider: React.FC<
  Omit<AzureContextProps, 'refreshContext'> & { children: React.ReactNode }
> = ({ api, azureConfigs, projectCode, children }) => {
  const refreshContext = useRefreshContext();

  return (
    <AzureContext.Provider
      value={{
        api,
        azureConfigs,
        projectCode,
        refreshContext,
      }}
    >
      {children}
    </AzureContext.Provider>
  );
};
